/* eslint-disable no-unused-vars */
/* eslint-disable sonarjs/sonar-no-unused-vars */
/* eslint-disable sonarjs/no-dead-store */
/* eslint-disable sonarjs/table-header */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import cx from 'classnames';
import { Button, InputField, Select } from '@salt/components';
import { getProjects, getProjectUsers } from '../../api/users';
import ProjectsList from './ProjectsList';
import UsersList from './UsersList';
import CreateProjectModal from './create/CreateProjectModal';

const ProjectsScreen = ({ userDetail }) => {
  const [usersTotal, setUsersTotal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);

  const [filter, setFilter] = useState({ page: 0, keywords: '', project: '' });
  //   const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]);
  const [createProjectOpen, setCreateProjectOpen] = useState(false);
  const [unassignedUserCount, setUnassignedUserCount] = useState(0);

  const [selectedView, setSelectedView] = useState('projects');

  const fetchData = useCallback(async () => {
    // setLoading(true);
    try {
      const { projectItems, unassignedCount } = await getProjects({
        limit: 1000,
      });
      const { usersItems, uTotal, uGrandTotal } = await getProjectUsers({
        ...filter,
        project: filter.project === 'all' || filter.project === 'unassigned' ? '' : filter.project,
        unassigned: filter.project === 'unassigned' ? '1' : '0',
        skip: filter.page * 10,
      });

      setUnassignedUserCount(unassignedCount || 0);
      setGrandTotal(uGrandTotal);
      setProjects(projectItems);
      setUsers(usersItems);
      setUsersTotal(uTotal);
    } catch (error) {
      console.error(error.message);
    }
    // setLoading(false);
  }, [filter.page, filter.keywords, filter.project]);

  const onHandleProjectFilterChange = useCallback(
    (newVal) => {
      // const itemValue = projects.find((p) => p.id === newVal)?.name || '';
      setFilter({ ...filter, project: newVal === '0' ? '' : newVal });
    },
    [projects, filter]
  );

  const handlePageClick = useCallback(
    (dir) => {
      if (dir === 'next') {
        setFilter({ ...filter, page: filter.page + 1 });
      } else {
        setFilter({ ...filter, page: filter.page - 1 });
      }
    },
    [filter]
  );

  const handleChangeView = useCallback((view) => {
    setSelectedView(view);
    setFilter({ page: 0, keywords: '', project: '' });
  }, []);

  useEffect(() => {
    fetchData();
  }, [filter.page, filter.keywords, filter.project]);

  const [totalProjects, filteredProjects] = useMemo(() => {
    let tmpProjects = Array.from(projects);
    if (filter.keywords?.length > 0) {
      tmpProjects = tmpProjects.filter((p) =>
        p.name.toLowerCase().includes(filter.keywords.toLowerCase())
      );
    }

    const tProjects = tmpProjects.length;
    const paginatedProjects = tmpProjects.splice(
      filter.page * 10 || 0,
      filter.page * 10 + 10 || 10
    );

    return [tProjects, paginatedProjects];
  }, [projects, filter.keywords, filter.page]);

  return (
    <main
      style={{
        width: '100%',
        padding: '25px 50px',
      }}
    >
      <div className="text-sm font-medium text-center text-gray-500 w-[300px]">
        <ul className="flex flex-wrap -mb-px">
          <li className="flex-grow mx-6">
            <button
              type="button"
              onClick={() => handleChangeView('projects')}
              className={cx('w-full inline-block py-1 border-b-4 text-[24px]', {
                'border-[#F4F5F7] hover:border-gray-300 hover:text-gray-500 text-gray-400':
                  selectedView !== 'projects',
                'border-[#37C2D7] text-primary': selectedView === 'projects',
              })}
            >
              Projects
            </button>
          </li>
          <li className="flex-grow mx-6 ">
            <button
              type="button"
              onClick={() => handleChangeView('users')}
              className={cx('w-full inline-block py-1 border-b-4  text-[24px]', {
                'border-[#F4F5F7] hover:border-gray-300 hover:text-gray-500 text-gray-400':
                  selectedView !== 'users',
                'border-[#37C2D7] text-primary': selectedView === 'users',
              })}
              aria-current="page"
            >
              Users
            </button>
          </li>
        </ul>
      </div>
      <div className="flex mt-10">
        <div className="search w-[410px]">
          <InputField
            icon="search"
            iconPlacement="left"
            onChange={(event) => setFilter({ ...filter, keywords: event.target.value })}
            onClear={() => setFilter({ ...filter, keywords: '' })}
            placeholder={`Search ${selectedView === 'projects' ? 'Projects' : 'Users'}`}
            value={filter.keywords}
            labelBackgroundClass="peer-focus:bg-secondary peer-[:not(:placeholder-shown)]:bg-secondary"
            backgroundClass="bg-secondary-light"
          />
        </div>
        {selectedView === 'users' ? (
          <div className="mx-4">
            <Select
              icon="filter"
              onClick={onHandleProjectFilterChange}
              width="w-[200px]"
              labelBackgroundClass="group-focus:bg-secondary"
              backgroundClass="bg-secondary-light"
              permScroller={projects.length > 2}
              renderItems={[
                {
                  id: 'all',
                  render: () => {},
                  value: `All Users (${grandTotal})`,
                },
                {
                  id: 'unassigned',
                  render: () => {},
                  value: `Unassigned Users (${unassignedUserCount})`,
                },
                ...projects.map((p) => ({
                  id: p.id,
                  value: `${p.name} (${p.members_count || 0})`,
                  render: () => {},
                })),
              ]}
              value={projects.find((p) => p.id === filter.project)?.name || 'All Users'}
            />
          </div>
        ) : (
          <Button
            onClick={() => setCreateProjectOpen(true)}
            type="positive"
            className="max-w-[146px] h-[36px] ml-auto"
            paddingClassName="py-2"
          >
            Create Project
          </Button>
        )}
      </div>
      {selectedView === 'projects' && (
        <ProjectsList
          projects={filteredProjects}
          page={filter.page}
          total={totalProjects}
          handlePageClick={handlePageClick}
        />
      )}
      {selectedView === 'users' && (
        <UsersList
          projects={projects}
          users={users}
          onNextPage={(event) => setFilter({ ...filter, page: event.selected })}
          page={filter.page}
          total={usersTotal}
          handlePageClick={handlePageClick}
          fetchData={fetchData}
        />
      )}
      {createProjectOpen && (
        <CreateProjectModal
          handleCreateProjectModalClose={() => setCreateProjectOpen(false)}
          fetchData={fetchData}
          customer={userDetail.customer}
        />
      )}
    </main>
  );
};

export default ProjectsScreen;
